<h2 mat-dialog-title>Add {{ serviceProvider.name }} Admin</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-form-field class="w-100">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" type="email" />
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="text" />
    </mat-form-field>

    @if (error) {
    <app-alert class="mt-3" type="error" (close)="error=null">
      {{ error }}
    </app-alert>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button [disabled]="loading" mat-button mat-dialog-close>Cancel</button>
  @if (loading) {
  <mat-spinner class="me-2" diameter="30" />
  }
  <button [disabled]="loading" mat-button (click)="onFormSubmit()">
    Add Admin
  </button>
</mat-dialog-actions>
